$shm_hitalama_map_widget_float_page $mol_page
	name? \
	title_content /
		<= Name $mol_string_button
			value? <=> name?
	body <= content /$mol_view
